import React from 'react'
import PropTypes from 'prop-types'
import ExtraQuestion from './ExtraQuestion'
import ExtraQuestionButtons from './ExtraQuestionButtons'

const ExtraQuestions = ({
  extraQuestions,
  handleAddExtraQuestion,
  handleDeleteExtraQuestion,
  onQuestionChange,
}) => (
  <React.Fragment>
    <span>
      To add an additional required question to the patient form, please fill
      out
      <strong> ALL</strong> 4 fields below
    </span>
    {extraQuestions.map((extraQuestion, idx) => (
      <ExtraQuestion
        extraQuestion={extraQuestion}
        extraQuestionIdx={idx}
        key={idx}
        onQuestionChange={onQuestionChange}
      />
    ))}
    <ExtraQuestionButtons
      extraQuestions={extraQuestions}
      handleAddExtraQuestion={handleAddExtraQuestion}
      handleDeleteExtraQuestion={handleDeleteExtraQuestion}
    />
  </React.Fragment>
)

ExtraQuestions.propTypes = {
  extraQuestions: PropTypes.arrayOf(PropTypes.object).isRequired,
  handleAddExtraQuestion: PropTypes.func.isRequired,
  handleDeleteExtraQuestion: PropTypes.func.isRequired,
  onQuestionChange: PropTypes.func.isRequired,
}

export default ExtraQuestions



// WEBPACK FOOTER //
// ./src/AddPractice/Info/SchedulingWidgetSnippet/ExtraQuestions/index.js